import { useCallback, useState } from 'react';

type UseQrScannerOptions = {
  validationPattern?: RegExp;
  onValidQrCode: (qrData: string) => void;
  onInvalidQrCode?: (qrData: string) => void;
};

type UseQrScannerReturn = {
  isOpen: boolean;
  openScanner: VoidFunction;
  closeScanner: VoidFunction;
  handleQrCodeRecognized: (qrData: string) => void;
};

export const useQrScanner = ({
  validationPattern,
  onValidQrCode,
  onInvalidQrCode,
}: UseQrScannerOptions): UseQrScannerReturn => {
  const [isOpen, setIsOpen] = useState(false);

  const openScanner = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeScanner = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleQrCodeRecognized = useCallback(
    (qrData: string) => {
      if (!validationPattern) {
        onValidQrCode(qrData);
        return;
      }

      if (validationPattern.test(qrData)) {
        onValidQrCode(qrData);
      } else {
        onInvalidQrCode?.(qrData);
      }
    },
    [validationPattern, onValidQrCode, onInvalidQrCode],
  );

  return {
    isOpen,
    openScanner,
    closeScanner,
    handleQrCodeRecognized,
  };
};
